export default function strToTime(date) {
    const d = date.split('.');
    return Math.round(new Date(`${d[2]}/${d[1]}/${d[0]}`).getTime() / 1000)
}
